var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container padded"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("posts")))]),_c('PostsBoard',{attrs:{"selected-topic-uid":_vm.topicUid}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }